<template>
  <div class="integral-award" ref="integral">
    <div class="centent-mobile">
      <Header></Header>
      <div class="box-top">
        <div class="text-bold">{{ $t("integralAwardPage.title") }}</div>
        <div class="text-encourage">{{ $t("integralAwardPage.content") }}</div>
      </div>
      <div class="box-cards">
        <div class="box-card">
          <div class="box-paypal">
            <img src="@/assets/img/p.png" />
          </div>
          <hr />
          <img class="paypal" src="@/assets/img/paypal.png" />
        </div>
        <div class="box-card">
          <div class="box-paypal gift">
            <img src="@/assets/img/gift.png" />
          </div>
          <hr />
          <div class="walmart">{{ $t("integralAwardPage.walmart") }}</div>
        </div>
        <div class="box-card">
          <img class="box-paypal gift" src="@/assets/pcImg/amazon.png" />

          <hr />
          <div class="walmart">amazon</div>
        </div>
      </div>
      <!-- 页脚 -->
      <Footer></Footer>
    </div>
  </div>
</template>
<script>
import Footer from "../../components/mycom/footer.vue";
import Header from "../../components/mycom/header.vue";

export default {
  components: { Footer, Header },
  data() {
    return {
      showSheet: false,
      showLangSheet: false,
      actions: [
        /*{ id: "1", name: "中文" },*/
        { id: "2", name: "English" },
      ],
    };
  },

  methods: {
    toHome() {
      this.$router.push({
        path: `/`,
      });
    },
    gourl() {
      this.$router.push({
        path: `register`,
      });
    },
    openSheet() {
      console.log(123);
      this.showSheet = !this.showSheet;
    },
    onSelect(value) {
      if (value.id == "1") {
        this.$i18n.locale = "zh";
      } else {
        this.$i18n.locale = "en";
      }
      localStorage.setItem("lang", this.$i18n.locale);
      this.showSheet = false;
      this.showLangSheet = false;
    },

    handleJump(flag) {
      switch (flag) {
        case 1:
          this.showLangSheet = true;
          break;
        case 2:
          this.$router.push("/integralAward");
          break;
        case 3:
          this.$router.push("/aboutQuestionnaire");
          break;
        case 4:
          this.$router.push("/helpFeedback");
          // this.$router.push("/offenQuestion");
          break;
        default:
          break;
      }
    },
  },
  mounted() {
    this.$refs.integral.scrollTop = 0;
  },
  created() {
    // 判断是否是全屏显示
    console.log("1111", localStorage.getItem("questionnaireItem"));
    setTimeout(() => {
      if (
        localStorage.getItem("questionnaireItem") == 0 ||
        !localStorage.getItem("questionnaireItem")
      ) {
        localStorage.setItem("questionnaireItem", 1);
        //this.$router.go(0);
      }
    }, 100);
    //修改title
    document.title =
      "Survey Rewards | Gift Cards | PayPal Cash | Weopinions description: Earn PayPal gift-cards and cash in exchange for the points that you collect by participating in Weopinions online surveys. Join now to collect points.";
  },
  beforeDestroy() {
    localStorage.setItem("questionnaireItem", 0);
  },
};
</script>
<style scoped>
.integral-award {
  height: 100vh;
  overflow: auto;
}
.centent-mobile {
  width: 100%;
  min-height: 100vh;
  margin: 0 auto;
  background-color: #f8f8f7;
  position: relative;
}
.box-top {
  position: relative;
  width: 100%;
  height: 164px;
  padding-top: 133px;
  background-image: url("../../assets/img/box-top.png");
  background-size: cover;
  color: #fff;
  margin-bottom: 36px;
}
header {
  position: fixed;
  top: 0;
  z-index: 9999;
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 3px 6px 1px #c6c5c6;
}
.box-add {
  width: 85px;
  height: 60px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  line-height: 60px;
  background-color: #2e67ea;
  text-align: center;
}
.pinios {
  width: calc(100% - 95px);
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  opacity: 0.8;
}
.pinios > img {
  width: 192px;
  height: 48px;
  cursor: pointer;
}
.develop {
  width: 35px;
  height: 60px;
  background-color: #fff;
  opacity: 0.8;
  display: flex;
  align-items: center;
}
.develop > img {
  width: 35px;
  height: 35px;
  margin-right: 12px;
}
.text-bold {
  position: relative;
  text-align: center;
  font-size: 26px;
  font-weight: bold;
  z-index: 99;
  /* margin-top: 73px; */
}
.text-encourage {
  position: relative;
  text-align: center;
  font-size: 16px;
  z-index: 99;
  margin-top: 34px;
}

.box-card {
  width: calc(100% - 30px);
  height: 194px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
  border: 1px solid #e3dfdf;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 22px;
}
.box-paypal {
  width: 132px;
  height: 89px;
  background: #d5f2ff;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 22px;
}
.box-paypal > img {
  width: 51px;
  height: 53px;
}
hr {
  width: calc(100% - 59px);
  height: 0px;
  opacity: 1;
  border: 1px solid #e5e1e1;
  margin-top: 22px;
}
.paypal {
  width: 64px;
  height: 17px;
  margin-top: 21px;
}
.gift {
  background: #004094;
}
.walmart {
  font-size: 14px;
  font-weight: bold;
  margin-top: 21px;
}
</style>

<style scoped>
@media only screen and (min-width: 768px) {
  .box-card {
    width: 30%;
    height: 194px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    border: 1px solid #e3dfdf;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 22px;
  }
  .box-cards {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/integralAward/IntegralAward.vue